<template>
  <div class="checkout-header bg-white flex-lr cursor" :class="hasTest()?'test-style':''">
    <div class="flex-lm">
      <div class="flex align-center"  @click="gotoHome">
        <img src="https://assets.pfotoo.com/wukong/logo.png"
             style="width: 50px;height: 50px;"></img>
        <span class="text-xxl text-black text-500 margin-left-sm cursor">{{headerTitle||'支付中心'}}</span>
      </div>
      <div class="header-left">
        <slot name="act"></slot>
      </div>
    </div>
    <div class="header-right flex-rr">
      <slot name="search"></slot>
      <a @click="gotoHome" class="black-font font-size14" style="margin-right: 20px;">返回活动管理</a>
      <a href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B" target="_blank" style="padding-top: 2px;" class="flex-lm">
        <img src="https://assets.pfotoo.com/pc/img/service.svg" style="width: 20px;height: 20px;margin-right: 5px;"/>
        <div class="black-font font-size14">客服</div>
      </a>
      <div class="user flex-vc">
        <memberAvatar :userinfo="userinfo"></memberAvatar>
        <!--
        <img :src="userinfo.avatar" class="header-img"/>
        <div class="login-out" @click="logout">
          <div class="login-out-angle bg-white"></div>
          <div style="height: 10px;"></div>
          <div class="login-out-font black-font font-size14 flex-cm bg-white">退出</div>
        </div>
        -->
      </div>
    </div>
  </div>

</template>

<script>
  import App from '../../../util/comfun'
  import memberAvatar from '../../../components/dialog/memberAvatar.vue'
  export default {
    name: 'header',
    data () {
      return {
        userinfo:{

        },
        isManager:false,
        headerTitle:'支付中心',
      }
    },
    components:{
      memberAvatar
    },
    methods:{
      getuserinfo(){
        App.User.GetUserById().then(res=>{
          if(res.code==200){
            this.userinfo=res.data
          }

        })
        //this.userinfo=JSON.parse(sessionStorage.getItem('userinfo'))
        return;
       this.$http({
         url:'https://pfotoo.com?s=App.User.GetUserById'+this.$getsign(),
         params:{
           openid:JSON.parse(localStorage.getItem('userinfo')).openid
         },
         dataType:'json',
         method:'POST',
         headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
         },
       }).then((res)=>{
         console.log(res.body)
         let json=res.body;
         if(res.body.ret==200){
            this.userinfo=json.data;
           localStorage.setItem('userinfo',JSON.stringify(json.data))
         }
       })
     },
     logout(){
       console.log('ttttt')
       localStorage.removeItem('userinfo');
       this.$router.replace({
         path:'/'
       })
     },
      hasTest:App.hasTestStyle,
      gotoHome(){
        this.$router.back()
      },
      setTitle(){
        if(this.$route.name=="packDown"){
          this.headerTitle='打包下载'
        }else{
          this.headerTitle='支付中心'
        }
      },
    },
    mounted(){
      this.getuserinfo();
      App.User.GetOperate().then(res=>{
        if(res.code==200 && res.data){
          this.isManager=res.data.isManager
        }
      })
    },
  }
</script>

<style>
  .checkout-header {
      height: 67px;
      left: 0px;
      padding: 0 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      z-index: 99;
      -webkit-box-shadow: 0 0 4px 1px rgba(0,0,0,.05);
      box-shadow: 0 0 4px 1px rgba(0,0,0,.05);
      position: fixed;
      right:0;
      top:0;
  }
  .user {
      position: relative;
      cursor: pointer;
      margin-left: 20px;
  }
  .login-out {
      width: 90px;
      height: 50px;
      position: absolute;
      right: -30px;
      top: 67px;
      border-radius: 2px;
      display: none;
  }
  .login-out-angle{
      width: 10px;
      height: 10px;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      position: absolute;
      top: 5px;
      left: 0;
      right: 0;
      margin: 0 auto;
  }
  .login-out-font {
      width: 100%;
      height: 40px;
      position: relative;
      z-index: 2;
  }
  .login-out-angel,.login-out-font{
      border-radius: 2px;
      -webkit-box-shadow: 0 0 4px rgba(0,0,0,.1);
      box-shadow: 0 0 4px rgba(0,0,0,.1);
  }
  a, a:hover {
      text-decoration: none;
  }
  .user:hover .login-out{
    display: block;
  }
  .el-menu-vertical-demo.el-menu{
    margin-left: -40px;
    border-right-width:0;

  }
</style>



// WEBPACK FOOTER //
// src/pages/components/checkout/header.vue